import * as datetimeLocalTZ from './datetimeLocalTZ';
import * as datetimeWithTZ from './datetimeWithTZ';
import * as duration from './duration';
import priceDurationText from './priceDurationText';
import priceInterval from './priceInterval';
import priceWithCurrency from './priceWithCurrency';
import * as withT from './priceWithT';
import recurringPrice from './recurringPrice';

export { default as csl } from './csl';
export { default as twoDigits } from './twoDigits';
export { default as messageOwnerName } from './messageOwnerName';
export { default as actionSubtext } from './workflows/actionSubtext';
export { default as actionText } from './workflows/actionText';
export { default as triggerTitle } from './workflows/triggerTitle';
export { default as stepName } from './workflows/stepName';
export { default as stepNameCustomer } from './workflows/stepNameCustomer';
export { default as fileSize } from './fileSize';
export { default as percentageComplete } from './percentageComplete';
export { default as productType } from './productType';
export { formatDuration, formatDurationBetween, formatElapsedTime } from './duration';

export const price = {
  durationText: priceDurationText,
  interval: priceInterval,
  recurring: recurringPrice,
  withCurrency: priceWithCurrency,
};

export const priceWithT = {
  price: withT.price,
  recurring: withT.recurring,
  sessionDuration: withT.sessionDuration,
};

export { datetimeLocalTZ, datetimeWithTZ, duration };
